// extracted by mini-css-extract-plugin
export default {"table-body-row":"styles_table-body-row__U3yNd","opacity":"styles_opacity__rrrjk","token-cell":"styles_token-cell__EVJWC","no-tokens-label":"styles_no-tokens-label__Xufv4"};